// extracted by mini-css-extract-plugin
export default {"container":"Pk-z","freeShip":"Qk-z","privacy":"Rk-z"};